import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookie from "cookie-universal";

const baseUrl = `${process.env.REACT_APP_API_URL}/users`;
// const baseUrl = "http://localhost:5000/api/users"
const cookie = Cookie();
export const authUser = createAsyncThunk(
    "auth/authUser",
    async ({ form, endPoint }, { rejectWithValue }) => {
        try {
            const res = await axios.post(`${baseUrl}/${endPoint}`, form);
            const token = res.data.token;
            const userId = res.data.user._id;

            console.log(userId);
            
            cookie.set("token", token);
            cookie.set("userId", userId);
            
            return { user: res.data.user, token: token };
        } catch (error) {
            if (!error.response) {
                return rejectWithValue({ networkError: "Network error. Please check your connection." });
            }
            
            if (error.response?.data.email || error.response?.data.password) {
                return rejectWithValue({ backendAuthErrors: error.response.data });
            }
            
            if (error.response?.data.message === "something went wrong.") {
                return rejectWithValue({ serverError: error.response.data.message });
            }
            
            return rejectWithValue({ unknownError: "Something went wrong, please try again." });
            
        }
    }
);
